














































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component

export default class RuleScriptTabComponent extends Vue {
  @Prop({ default: false }) hasHistory!: boolean;

  tab: number = 0;

  items: Array<string> = ['Nomenclaturas'];

  @Watch('tab')
  selectTab() {
    this.$emit('selectTab', this.tab);
  }
}

